import { HostListener, Inject, Component, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SharedContainer } from '../../shared.container';

@Component({
  selector: 'app-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.css']
})
export class BackToTopComponent implements OnInit {

  constructor( @Inject(DOCUMENT) private document: Document,
  protected sharedContainer: SharedContainer) { }

  ngOnInit() {
  }

  @HostListener('window:scroll', []) onWindowScroll() {
    this.scrollFunction();
  }
  // When the user scrolls down 20px from the top of the document, show the button
scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById('myBtn').style.display = 'block';
    } else {
        document.getElementById('myBtn').style.display = 'none';
    }
}

// When the user clicks on the button, scroll to the top of the document
topFunction() {
    this.document.body.scrollIntoView({behavior : 'smooth'});
}
}
